import { Injectable, Injector, ViewContainerRef, createNgModule, inject } from '@angular/core';

import { BehaviorSubject, ReplaySubject, take } from 'rxjs';

import { BusinessHours } from '@hdms/shared/page-frame/data-access';
import { UserAccountData } from '@hdms/shared/page-frame/types';

@Injectable()
export class ContactBodyLoaderService {
  readonly loaded$ = new ReplaySubject<BusinessHours>(1);
  readonly isSubmitBtnEnabled$ = new BehaviorSubject<boolean>(true);

  private readonly injector = inject(Injector);

  setSubmitButtonEnabled(state: boolean): void {
    this.isSubmitBtnEnabled$.next(state);
  }

  async loadBodyComponent(ref: ViewContainerRef, userData: UserAccountData): Promise<void> {
    const { ContactBodyContentComponent, ContactBodyContentModule } = await import(
      './content/contact-body-content.module'
    );
    const ngModuleRef = createNgModule(ContactBodyContentModule, this.injector);
    const bodyComponent = ref.createComponent(ContactBodyContentComponent, {
      ngModuleRef
    });

    const { instance } = bodyComponent;
    instance.userData = userData;
    instance.businessHours$.pipe(take(1)).subscribe(data => this.loaded$.next(data));

    bodyComponent.changeDetectorRef.detectChanges();
  }
}
